module.exports = __webpack_public_path__ + "378c13ac5c76029baa90620cf21db62c.png";